module.exports = __webpack_public_path__ + "static/media/company.20d43b2d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/company.svg
// module id = 614
// module chunks = 0